import React from 'react';
import './AppPart.scss';
const AppPart=(props)=>{
    return(
        <div  className={`app-frame ${props.styles}`}>
            <div className="content">
                <h1>{props.title}</h1>
                <p>{props.desc}</p>
               <div className="btns">
               {props.backgroundImage1 ?  <div className="playbtn" style={{ backgroundImage: `url(${props.backgroundImage1})` }}></div> : null}
               {props.backgroundImage2 ? <div className="appbtn" style={{ backgroundImage: `url(${props.backgroundImage2})` }}></div> : null}
               </div>
            </div>

            <img src={props.image} />
        </div>
    )
};
export default AppPart ;